import React from "react";
import PropTypes from "prop-types";

import FinancialRow from "./FinancialRow";

const FinancialEntry = ({
  displayName,
  financialDataFieldName,
  financialData,
  classes,
  isNegative,
  dontShowBeforeYear,
}) => (
  <FinancialRow
    displayName={displayName}
    financialDataFieldName={financialDataFieldName}
    financialData={financialData}
    classes={classes}
    insertDivider={false}
    bold={false}
    underlined={false}
    isNegative={isNegative}
    hasLeftMargin
    hasVerticalSpacing={false}
    dontShowBeforeYear={dontShowBeforeYear}
  />
);

FinancialEntry.propTypes = {
  displayName: PropTypes.string.isRequired,
  financialDataFieldName: PropTypes.string.isRequired,
  financialData: PropTypes.shape({
    years: PropTypes.arrayOf(
      PropTypes.shape({
        year: PropTypes.number.isRequired,
      })
    ),
    cumulative: PropTypes.objectOf(PropTypes.number),
  }).isRequired,
  // eslint-disable-next-line react/forbid-prop-types -- See financialTableStyles
  classes: PropTypes.object.isRequired,
  isNegative: PropTypes.bool,
  dontShowBeforeYear: PropTypes.number,
};

FinancialEntry.defaultProps = {
  isNegative: false,
  dontShowBeforeYear: undefined,
};

export default FinancialEntry;
